'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var transport = require('../../transport/transport.js');

class Signup {
  getCurrencies() {
    return transport.transport.request("signup/currencies");
  }
  registrationTypes() {
    return transport.transport.request("signup/registrationTypes");
  }
  getRegDDLists() {
    return transport.transport.request("signup/getRegDDLists");
  }
  checkEmail(params) {
    return transport.transport.request("signup/checkEmail", params);
  }
  getOccupations(params) {
    return transport.transport.request("signup/occupations", params);
  }
  getOccupationsByRegulation(params) {
    return transport.transport.request("signup/occupationsByRegulation", params);
  }
  getNationalities() {
    return transport.transport.request("signup/getNationalities");
  }
  checkUsername(params) {
    return transport.transport.request("signup/checkUsername", params);
  }
  getSubdivisions(params) {
    return transport.transport.request("signup/getSubdivisions", params);
  }
  getIndustries() {
    return transport.transport.request("signup/getIndustries");
  }
  addressFinder(params) {
    return transport.transport.request("signup/addressFinder", params);
  }
  addressFinderMetadata(params) {
    return transport.transport.request("signup/addressFinderMetadata", params);
  }
  getPepSourceOfWealth() {
    return transport.transport.request("signup/getPepSourceOfWealth");
  }
  getPepSourceOfFunds() {
    return transport.transport.request("signup/getPepSourceOfFunds");
  }
  getPepCategories() {
    return transport.transport.request("signup/getPepCategories");
  }
}

exports.Signup = Signup;
